import { Text, useText } from "@sveabank/cc-common";
import { usePageContext } from "../../../../hooks/context";
import type { ClcPerson } from "../../../../types/clc-application";
import { useClcCompanyApplication } from "../../hooks";

type Props = {
	person: ClcPerson;
};

const ClcPersonRoles = ({ person }: Props) => {
	const {
		clcApplicationDetails: {
			companyShares,
			beneficialOwners: beneficialOwnership,
			representatives,
		},
		roles: allRoles,
	} = usePageContext(useClcCompanyApplication);

	const [t, texts] = useText();

	const shareholders = companyShares.value?.shareholders || [];
	const beneficialOwners = beneficialOwnership.value?.beneficialOwners || [];
	const companyRepresentatives = representatives.value?.representatives || [];

	const isShareholder = shareholders.some((s) => s.nationalId === person.nationalId);
	const isBeneficialOwner = beneficialOwners.some((b) => b.nationalId === person.nationalId);
	const representativeRoles =
		companyRepresentatives.find((r) => r.nationalId === person.nationalId)?.functions || [];

	const personRoles = [
		...(isShareholder ? [t(texts.newCompany.shareholder)] : []),
		...(isBeneficialOwner ? [t(texts.newCompany.beneficialOwner)] : []),
		...(representativeRoles.length > 0
			? [
					representativeRoles
						.map((r) => allRoles.find((role) => role.value === r)?.label)
						.join(", "),
				]
			: []),
	].join(", ");

	return <Text>{personRoles}</Text>;
};

export default ClcPersonRoles;
